import React, { Suspense } from 'react';
import CircularProgress from '../../../components_base/CircularProgress';


const CounterpartyDetail = React.lazy(() => import('../components/CounterpartyDetail'));
function CounterpartyDetailView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <CounterpartyDetail {...props} />
    </Suspense>
  );
}

export default CounterpartyDetailView;
